'use client'

import { useQuery } from '@tanstack/react-query'
import { useParams } from 'next/navigation'

import { contractQueries } from '@/entities/contract'

type Props = {
  contractId?: number
}

export const useGuestRefundCard = ({
  contractId: contractIdProp,
}: Props = {}) => {
  const params = useParams()
  const contractId = Number(params?.contractId)

  const { data: refundCard } = useQuery({
    ...contractQueries.guestRefundCard({
      contractId: contractIdProp ?? contractId,
    }),
    enabled: false,
    meta: {
      useCustomHandling: true,
    },
  })

  return {
    refundCard,
  }
}
